import { GET_CHAT_USERS,GET_CHAT_USERS_SUCCESS,GET_CHAT_USERS_FAIL,GET_CHAT_USERS_RESET } from '../actions/getChatUsersAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getChatUsersReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_CHAT_USERS:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_CHAT_USERS_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_CHAT_USERS_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_CHAT_USERS_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getChatUsersReducer;
